import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bf-layout" }
const _hoisted_2 = { class: "bf-layout__header" }
const _hoisted_3 = {
  key: 0,
  class: "bf-layout__main-menu"
}
const _hoisted_4 = { class: "bf-layout__content" }
const _hoisted_5 = { class: "hardware-modules" }
const _hoisted_6 = { class: "hardware-modules__header" }

import { storeToRefs } from 'pinia'
import { BfIcon, Colors } from '@finetic/bikefitting-ui'
import { useProgressStore } from '@/store/progressStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'BikefittingLayout',
  props: {
    hasBike: { type: Boolean, default: false }
  },
  setup(__props: any) {



const progressStore = useProgressStore()

const { hardwareActive } = storeToRefs(progressStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$slots.mainMenu?.())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "mainMenu")
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "header"),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "bf-layout__buttons" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bf-layout__logo" }, null, -1)),
        (__props.hasBike && _ctx.$slots.hardwareHeader?.())
          ? _renderSlot(_ctx.$slots, "hardwareHeader", { key: 0 })
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "bf-layout__toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hardwareActive.value = !_unref(hardwareActive)))
        }, [
          (__props.hasBike && _ctx.$slots.hardwareModules?.())
            ? (_openBlock(), _createBlock(_unref(BfIcon), {
                key: 0,
                icon: 
              _unref(hardwareActive)
                ? '/icons/52-Arrows-Diagrams/01-Arrows/arrow-down-1.svg'
                : '/icons/52-Arrows-Diagrams/01-Arrows/arrow-up-1.svg'
            ,
                color: _unref(Colors).Light
              }, null, 8, ["icon", "color"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([
          'hardware-modules__content',
          { 'hardware-modules__content--active': _unref(hardwareActive) },
        ])
      }, [
        _renderSlot(_ctx.$slots, "hardwareModules")
      ], 2)
    ])
  ]))
}
}

})